import { render, staticRenderFns } from "./ReservingSession.vue?vue&type=template&id=5d837472&scoped=true&"
import script from "./ReservingSession.vue?vue&type=script&lang=js&"
export * from "./ReservingSession.vue?vue&type=script&lang=js&"
import style0 from "./ReservingSession.vue?vue&type=style&index=0&id=5d837472&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d837472",
  null
  
)

export default component.exports